import { Box, Fade } from '@mui/material';
import { createPortal } from 'react-dom';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import RachelChatLayout from '../RachelChatLayout/RachelChatLayout';
import { useRachelPanelStyles } from './rachelPanel.styles';
import { useRachelPanel } from './useRachelPanel';

const RachelPanel = () => {
  const { translate } = useTranslation();
  const {
    isAvailable,
    isOpen,
    presentation,
    hasExited,
    close,
    panelRef,
    handleEnter,
    handleExited,
  } = useRachelPanel();
  const { classes } = useRachelPanelStyles({ isOpen });

  if (!isAvailable || presentation.mode === 'page' || presentation.mode === 'none') {
    return null;
  }

  const chat = (
    <Fade in={isOpen} unmountOnExit onEnter={handleEnter} onExited={handleExited}>
      <Box className={classes.content}>
        <RachelChatLayout />
      </Box>
    </Fade>
  );

  if (presentation.isOverlaid) {
    return createPortal(
      <>
        <Fade in={isOpen} unmountOnExit>
          <Box className={classes.scrim} onClick={close} />
        </Fade>
        <Box
          ref={panelRef}
          className={classes.overlayPanel}
          role="dialog"
          aria-modal="true"
          aria-hidden={hasExited}
          aria-label={translate(LangEnum.RACHEL_DIALOG_TITLE)}
          tabIndex={-1}
        >
          {chat}
        </Box>
      </>,
      document.body,
    );
  }

  return (
    <Box ref={panelRef} className={classes.panel} aria-hidden={hasExited}>
      {chat}
    </Box>
  );
};

export default RachelPanel;
